import {pricingPlatformInit} from "./sliders/_pricing-platform";



$(document).ready(() => {

  pricingPlatformInit();

});